import { tv } from 'tailwind-variants';

export const styles = tv({
  slots: {
    product: 'bg-white px-4 py-4',
    stickyTotals: 'heading-xl font-[450]'
  }
});
